import React from 'react';
import PlaceholderBlock from '../../../PlaceholderBlock';

export interface Props {
  splitIndex?: number;
  className?: string;
}

// spec says nothing about sizes of these, so arbitrary numbers
const splits: [number, number][] = [
  [56, 160],
  [32, 64],
  [48, 32],
  [24, 80],
  [32, 120],
];

const TitlePlaceholder: React.FC<Props> = ({ className, splitIndex = 0 }) => {
  const [width1, width2] = splitIndex < splits.length ? splits[splitIndex] : splits[0];

  return (
    <div className={className}>
      <PlaceholderBlock width={width1} height={8} /> <PlaceholderBlock width={width2} height={8} />
    </div>
  );
};
TitlePlaceholder.displayName = 'TitlePlaceholder';

export default TitlePlaceholder;
